module.exports = __webpack_public_path__ + "static/media/IMG_4030 laundry high.b4708a99.JPG";